/* ballot_request_unit_search.js — the unit search on a ballot request's
   review page. The server renders every unit of the order as a list item
   with a pre-normalised search string and a match level; the units whose
   house number and street match the owner's address are shown first and
   highlighted. Typing filters the whole list; clicking a unit submits the
   hidden assign form.

   The query is normalised the same way the server normalises addresses, so
   typing "unit 6", "#6" or "apt 6" finds the same unit. */
(function (root) {
  'use strict';

  var UNIT_WORDS = ['unit', 'apt', 'apartment', 'ste', 'suite', 'no', 'number', 'num', 'bldg', 'building', 'fl', 'floor', 'rm', 'room', 'lot', 'space', 'spc'];

  function normalizeQuery(text) {
    var tokens = String(text || '').toLowerCase()
      .replace(/#/g, ' # ')
      .replace(/[^a-z0-9#\s]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);
    var out = [];
    for (var i = 0; i < tokens.length; i += 1) {
      var t = tokens[i];
      if (UNIT_WORDS.indexOf(t) !== -1) t = '#';
      if (t === '#' && out.length && out[out.length - 1] === '#') continue;
      out.push(t);
    }
    return out.join(' ').replace(/# (\S)/g, '#$1');
  }

  /* Which items to show for a query: every item whose search text contains
     each word of the normalised query. An empty query shows the matches. */
  function visibleItems(items, query) {
    var q = normalizeQuery(query);
    if (!q) {
      return items.filter(function (item) { return item.level !== 'none'; });
    }
    var words = q.split(' ');
    return items.filter(function (item) {
      return words.every(function (w) { return item.search.indexOf(w) !== -1; });
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeQuery: normalizeQuery, visibleItems: visibleItems };
  }

  if (typeof document === 'undefined') return;

  document.addEventListener('turbolinks:load', function () {
    var input   = document.getElementById('unit-search');
    var results = document.getElementById('unit-results');
    var form    = document.getElementById('unit-assign-form');
    var idField = document.getElementById('unit-assign-id');
    if (!input || !results || !form || !idField) return;

    var nodes = Array.prototype.slice.call(results.querySelectorAll('li.unit-result'));
    var empty = document.getElementById('unit-results-empty');
    var items = nodes.map(function (node) {
      return { node: node, search: node.dataset.search || '', level: node.dataset.level || 'none' };
    });

    function render() {
      var shown = visibleItems(items, input.value);
      items.forEach(function (item) { item.node.classList.add('hidden'); });
      shown.forEach(function (item) { item.node.classList.remove('hidden'); });
      if (empty) {
        empty.textContent = input.value.trim()
          ? 'No units match that search.'
          : (results.dataset.matchCount !== '0' ? '' : "Type to search the order's units.");
        empty.classList.toggle('hidden', shown.length > 0);
      }
    }

    function choose(node) {
      idField.value = node.dataset.unitId;
      form.submit();
    }

    input.addEventListener('input', render);
    nodes.forEach(function (node) {
      node.addEventListener('click', function () { choose(node); });
      node.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(node); }
      });
    });

    render();
  });
})(typeof window !== 'undefined' ? window : this);
